import type { NominationDocumentRow, NominationWizardDraft } from '../types/nominationCaseRequest';
import { FILE_CATEGORY_NOMINATION } from '../pages/wizard/nomination/nominationConstants';
import { isDocumentTypeUuid } from '../utils/documentTypeId';

export const DEFAULT_NOMINATION_DRAFT: NominationWizardDraft = {
  fileCategory: FILE_CATEGORY_NOMINATION,
  fileCategoryId: '',
  subFileCategoryId: '',
  subFileCategoryName: '',
  applicableAreas: [],
  applicableAreaIds: [],

  description: '',
  caseNumber: '',
  hasConnectedMatters: 'no',
  connectedCaseNumber: '',
  connectedAgdFileRef: '',

  urgencyLevelId: '',
  urgencyLevelName: '',
  deadline: '',
  urgencyJustification: '',

  deliveryMethodIds: [],
  deliveryMethods: [],
  deliveryOther: '',

  documents: [],
  confirmCorrect: false,

  draftRequestId: '',
  referenceNo: '',
};

export type NominationWizardContextValue = {
  draft: NominationWizardDraft;
  setDraft: React.Dispatch<React.SetStateAction<NominationWizardDraft>>;
  reset: () => void;
};

function normalizeDocLabel(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, ' ');
}

function findDocumentForChecklistItem(
  prev: NominationDocumentRow[],
  item: { id: string; documentTypeId: string; name: string; documentTypeCode?: string },
): NominationDocumentRow | undefined {
  return prev.find((d) => {
    if (d.checklistItemId === item.id) return true;
    if (item.documentTypeId && d.documentTypeId === item.documentTypeId) return true;
    if (item.documentTypeCode) {
      if (d.documentTypeId === item.documentTypeCode || d.checklistItemId === item.documentTypeCode) return true;
    }
    if (!isDocumentTypeUuid(d.documentTypeId) && normalizeDocLabel(d.documentName) === normalizeDocLabel(item.name)) {
      return true;
    }
    return false;
  });
}

export function syncNominationDocumentsFromChecklist(
  prev: NominationDocumentRow[],
  checklist: { id: string; documentTypeId: string; name: string; mandatory: boolean; documentTypeCode?: string }[],
): NominationDocumentRow[] {
  return checklist.map((item) => {
    const existing = findDocumentForChecklistItem(prev, item);
    if (existing) {
      return {
        ...existing,
        checklistItemId: item.id,
        documentTypeId: item.documentTypeId,
        documentName: item.name,
        mandatory: item.mandatory,
      };
    }
    return {
      id: crypto.randomUUID(),
      checklistItemId: item.id,
      documentTypeId: item.documentTypeId,
      documentName: item.name,
      mandatory: item.mandatory,
      fileName: '',
      originalFileName: '',
      uploadTime: '',
      skipReason: '',
    };
  });
}
